import * as React from 'react';

import PropTypes from 'prop-types';

import {ChevronDownIcon, ChevronRightIcon, ArrowUpIcon, ArrowDownThinIcon} from 'shells/icon';

import styles from './list-toggle-header.module.css';

export class ListToggleHeader extends React.Component {
    static propTypes = {
        text: PropTypes.string,
        count: PropTypes.number,
        onClick: PropTypes.func,
        isLoading: PropTypes.bool,
        loadingText: PropTypes.string,
        isOpen: PropTypes.bool.isRequired,
        sortDirection: PropTypes.oneOf(['asc', 'desc']),
        onSortToggle: PropTypes.func,
    };

    static defaultProps = {
        onClick: () => {},
        text: '',
    };

    render() {
        const {sortDirection} = this.props;
        const SortIconComponent = sortDirection === 'asc' ? ArrowUpIcon : ArrowDownThinIcon;

        return (
            <div className={this.props.isOpen ? styles['container-open'] : styles.container}>
                <div className={styles['header']} onClick={this.handleClick}>
                    {this.props.isLoading ? (
                        <div className={styles['left-section']}>{this.props.loadingText}</div>
                    ) : (
                        <div className={styles['left-section']}>
                            <span className={styles['chevron-icon']}>
                                {this.props.isOpen ? <ChevronDownIcon /> : <ChevronRightIcon />}
                            </span>
                            <span>{this.props.text}</span>
                            <span className={styles.count}>{this.props.count}</span>
                        </div>
                    )}
                </div>
                {this.props.isOpen && sortDirection ? (
                    <button className={styles['sort-toggle']} onClick={this.handleSortToggle}>
                        <SortIconComponent size={11} />
                        {sortDirection === 'asc' ? 'Oldest first' : 'Newest first'}
                    </button>
                ) : null}
            </div>
        );
    }

    handleClick = () => {
        if (!this.props.isLoading) this.props.onClick();
    };

    handleSortToggle = (event) => {
        event.stopPropagation();
        if (this.props.onSortToggle) {
            this.props.onSortToggle();
        }
    };
}
